import { Input } from "../../../../components/ui/input";
import { Button } from "../../../../components/ui/button";
import { Search, Plus } from "lucide-react";

interface LibraryToolbarProps {
  searchTerm: string;
  onSearchTermChange: (term: string) => void;
  onAddItem: () => void;
  canEdit: boolean;
}

export function LibraryToolbar({
  searchTerm,
  onSearchTermChange,
  onAddItem,
  canEdit,
}: LibraryToolbarProps) {
  return (
    <div className="flex items-center gap-4 mb-4 w-full">
      <div className="relative flex-1">
        <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-stone-400" />
        <Input
          placeholder="Search by ID or name..."
          value={searchTerm}
          onChange={(e) => onSearchTermChange(e.target.value)}
          className="pl-9"
        />
      </div>
      {canEdit && (
        <Button onClick={onAddItem}>
          <Plus className="h-4 w-4 mr-2" />
          Add Item
        </Button>
      )}
    </div>
  );
}
